export default [
    "ic_corona",
    "legal_consulting",
    "study_consulting",
    "psychological_consulting",
    "specific_needs",
    "career_consulting"
];